import { useTheme } from 'vuetify';
import { toRefs, reactive } from 'vue';

/**
 *
 */
export function useColors() {
  const { colors } = useTheme().current.value;

  return { ...toRefs(reactive(colors)) };
}
